// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T3RW","col":"styles_col__19_Om"};